import request from "./request";

const interviews = {
  service() {
    return {
      getUsageTypes(params) {
        params.pageIndex = !params.pageIndex ? 0 : params.pageIndex;
        params.pageSize = !params.pageSize ? 200 : params.pageSize;

        return request.get("/interviews-api/content-items/usageTypes", params);
      },
      getUsageGroups(params) {
        params.pageIndex = !params.pageIndex ? 0 : params.pageIndex;
        params.pageSize = !params.pageSize ? 200 : params.pageSize;

        return request.get("/interviews-api/content-items/usages", params);
      },
      getAudiences(params) {
        params.pageIndex = !params.pageIndex ? 0 : params.pageIndex;
        params.pageSize = !params.pageSize ? 200 : params.pageSize;

        return request.get("/interviews-api/content-items/audiences", params);
      },
      getPartners(partnerId) {
        return request.get(`/interviews-api/partners/${partnerId}`);
      },
      getSimulation(usageId, audiences) {
        let audienceParam = "";
        if (audiences.length > 0) {
          audienceParam = `&audiences=${audiences.join("&audiences=")}`;
        }

        return request.get(
          `/interviews-api/content-items/best-match?usageId=${usageId}${audienceParam}`,
        );
      },
      searchSimulations(params) {
        return request.get(`/interviews-api/content-items/all-match`, params);
      },
      getContentFor(contentItemId) {
        return request.get(
          `/interviews-api/content-items/all-match?contentItemId=${contentItemId}`,
        );
      },
      getHistoryFor(contentItemId, params) {
        return request.get(
          `/interviews-api/content-items/history?contentItemId=${contentItemId}`,
          params,
        );
      },
      getBrokerLeads(params) {
        return request.get("/interviews-api/brokerLeads", params);
      },
      getLead(oppId) {
        return request.get(`/interviews-api/brokerLeads/${oppId}`);
      },
      getOpportunityStatusStats(brokerId, params) {
        return request.get(
          `/interviews-api/brokerLeads/${brokerId}/opportunityStatusStats`,
          params,
        );
      },
      getLeadsBySource(brokerId) {
        return request.get(
          `/interviews-api/brokerLeads/leadSourceCount/${brokerId}`,
        );
      },
      getReferralStageStats(brokerId, source) {
        return request.get(
          `/interviews-api/brokerLeads/${brokerId}/referralStageStats?cleanReferringWebsite=${source}`,
        );
      },
      patchHtmlContent(contentId, data) {
        return request.patch(
          `/interviews-api/content-items/${contentId}`,
          data,
        );
      },
      getOpportunityContactNumbers(params) {
        return request.get(`/interviews-api/contactNumbers`, params);
      },
      getZipCode(zip) {
        return request.get(`/interviews-api/geography/zipCodes/${zip}`);
      },
      getMarkets(params) {
        return request.get(`/interviews-api/markets`, params);
      },
      getOpportunityLender(id) {
        return request.get(`/interviews-api/opportunities/${id}/lender`);
      },
      getEscalations(params) {
        return request.get("/interviews-api/agent-support/cases", params);
      },
      getAreaSearch(params) {
        return request.get(`/interviews-api/geography`, params);
      },
      postBulkSMSSend(formData) {
        return request.postFile(
          "/interviews-api/opportunities/sms",
          formData,
          null,
        );
      },
    };
  },
};

export default interviews;
